/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name cellweek
 */
angular.module('mercury.modules.time.roster')
.directive('cellweek', function() {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element) {

      if (!scope.isTemplate) {
        // If the cell has to be disabled because the roster that the cell belongs
        // to is published then we don't want the week-cell class and we also don't
        // want the user to be able to click on the cell and keep adding/updating
        // shifts
        //
        // Note templates are always editable.
        var cellIsDisabled = scope.days != null && scope.days[scope.dayIndex] ?
          scope.disableCell(scope.days[scope.dayIndex].startTime) : false;
        if (cellIsDisabled) {
          element.removeClass('week-cell');
          return;
        }
      }

      /*
      * If the cell is clicked, the editor should be opened.
      */
      element.on('click', function(e) {
        if (e.currentTarget) {
          angular.element(e.currentTarget).removeClass('ui-draggable-dragging');
        }

        // disable editing a day if any shifts are currently saving
        for (var i in scope.rosterCells[scope.member.id][scope.dayIndex]) {
          if (typeof scope.rosterCells[scope.member.id][scope.dayIndex][i].saving != 'undefined' && scope.rosterCells[member.id][scope.dayIndex][i].saving) {
            return;
          }
        }

        //On iOS Safari, the click event can be triggered while dragging a shift. This will prevent the edit dialog from opening
        var isDragging = false;
        angular.element(e.currentTarget)
        .find('.shift-container').each(function() {
          var shiftMoved = angular.element(this).data('moved');
          if (shiftMoved) {
            isDragging = true;
          }
        });

        if (isDragging) {
          return;
        }

        if (scope.day.length > 0) {
          scope.openEditDialog({
            rosterCells: scope.day,
            staff: scope.staff,
            roles: scope.roles,
            saveCb: scope.save,
            startTime: scope.days[scope.dayIndex].startTime
          });
        } else {
          scope.openEditDialog({
            rosterCells: {
              shifts: [{
                roleId: scope.member.defaultMemberRoleRoleId,
                roleName: scope.member.defaultMemberRoleRoleName,
                staffMemberId: scope.member.id,
                clockinTime: moment(scope.viewStartDateTime).add(scope.dayIndex, 'days').format(),
                clockoutTime: moment(scope.viewStartDateTime).add(scope.dayIndex, 'days').add(180, 'minutes').format(),
                breaks: []
              }]
            },
            staff: scope.staff,
            roles: scope.roles,
            saveCb: scope.save,
            startTime: scope.days[scope.dayIndex].startTime
          });
        }
      });

      /*
      * Configure the drop zone for shift moving or filling.
      */
      element.droppable({
        over: function(event, ui) {
          angular.element('#editor-body').find('td.active').removeClass('active');

          if ($(ui.draggable).hasClass('shift-fill')) {
            var editorRow = element.parent();
            var originalIndex = ui.draggable.data('startDay');

            editorRow.find('td:not(:first-child)')
            .each(function(index) {
              if (index > originalIndex && index <= scope.dayIndex) {
                angular.element(this).addClass('active');
              }
            });
          } else {
            element.addClass('active');
          }

          var onOverCallback = ui.draggable.data('onOverCallback');
          if (angular.isFunction(onOverCallback)) {
            onOverCallback(scope.member, scope.dayIndex);
          }
        },
        drop: function(event, ui) {
          if ($(ui.draggable).hasClass('week-shift')) {
            // Snap the draggable to the cell.
            $(ui.draggable).detach().css({top: 0,left: 0}).appendTo(this);
          }
        }
      });
    }
  };
});
